import { PIC, Util, openChoiceBox, loadPage, PICInput, PICLoadPage, objectDecoder, PICAction } from '../templates/Internals';
const LOOKUP = [0, -16191, -15999, 320, -15615, 960, 640, -15807, -14847, 1728, 1920, -14527, 1280, -14911, -15231, 1088, -13311, 3264, 3456, -12991, 3840, -12351, -12671, 3648, 2560, -13631, -13439, 2880, -14079, 2496, 2176, -14271, -10239, 6336, 6528, -9919, 6912, -9279, -9599, 6720, 7680, -8511, -8319, 8000, -8959, 7616, 7296, -9151, 5120, -11071, -10879, 5440, -10495, 6080, 5760, -10687, -11775, 4800, 4992, -11455, 4352, -11839, -12159, 4160, -4095, 12480, 12672, -3775, 13056, -3135, -3455, 12864, 13824, -2367, -2175, 14144, -2815, 13760, 13440, -3007, 15360, -831, -639, 15680, -255, 16320, 16000, -447, -1535, 15040, 15232, -1215, 14592, -1599, -1919, 14400, 10240, -5951, -5759, 10560, -5375, 11200, 10880, -5567, -4607, 11968, 12160, -4287, 11520, -4671, -4991, 11328, -7167, 9408, 9600, -6847, 9984, -6207, -6527, 9792, 8704, -7487, -7295, 9024, -7935, 8640, 8320, -8127, -24575, 24768, 24960, -24255, 25344, -23615, -23935, 25152, 26112, -22847, -22655, 26432, -23295, 26048, 25728, -23487, 27648, -21311, -21119, 27968, -20735, 28608, 28288, -20927, -22015, 27328, 27520, -21695, 26880, -22079, -22399, 26688, 30720, -18239, -18047, 31040, -17663, 31680, 31360, -17855, -16895, 32448, 32640, -16575, 32000, -16959, -17279, 31808, -19455, 29888, 30080, -19135, 30464, -18495, -18815, 30272, 29184, -19775, -19583, 29504, -20223, 29120, 28800, -20415, 20480, -28479, -28287, 20800, -27903, 21440, 21120, -28095, -27135, 22208, 22400, -26815, 21760, -27199, -27519, 21568, -25599, 23744, 23936, -25279, 24320, -24639, -24959, 24128, 23040, -25919, -25727, 23360, -26367, 22976, 22656, -26559, -30719, 18624, 18816, -30399, 19200, -29759, -30079, 19008, 19968, -28991, -28799, 20288, -29439, 19904, 19584, -29631, 17408, -31551, -31359, 17728, -30975, 18368, 18048, -31167, -32255, 17088, 17280, -31935, 16640, -32319, -32639, 16448];
function hashIt(scratch, hash) {
    for (var i = 15; i >= 0; i--) {
        hash = (((hash & 65535) >> 8 ^ LOOKUP[hash & 255] ^ LOOKUP[(scratch[i] & 255)]) | 0);
    }
    ;
    return hash;
}
;
function ProgressEncode(str) {
    if (str == null) {
        return null;
    }
    var input = (str).split('').map(function (s) { return s.charCodeAt(0); });
    var scratch = (function (s) { var a = []; while (s-- > 0)
        a.push(0); return a; })(16);
    var hash = 17;
    for (var i = 0; i < 5; i++) {
        for (var j = 0; j < input.length; j++) {
            //@ts-ignore
            scratch[15 - (j % 16)] ^= input[j];
        }
        ;
        for (var j = 0; j < 16; j += 2) {
            hash = hashIt(scratch, hash);
            scratch[j] = ((hash & 255) | 0);
            scratch[j + 1] = (((hash >> 8) & 255) | 0);
        }
        ;
    }
    ;
    var target = (function (s) { var a = []; while (s-- > 0)
        a.push(0); return a; })(16);
    for (var i = 0; i < 16; i++) {
        //@ts-ignore
        var lower = ((scratch[i] & 127) | 0);
        if (lower >= 'A'.charCodeAt(0) && lower <= 'Z'.charCodeAt(0) || lower >= 'a'.charCodeAt(0) && lower <= 'z'.charCodeAt(0)) {
            target[i] = lower;
        }
        else {
            //@ts-ignore
            target[i] = ((((scratch[i] & 255) >> 4) + 97) | 0);
        }
    }
    ;
    return String.fromCharCode.apply(null, target);
}
;
const checkPreventableEvent = (preventEventElm, eventId) => {
    var _a, _b;
    if (preventEventElm == null)
        return false;
    let attrLst = (_b = (_a = preventEventElm.getAttribute('eventlst')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
    return attrLst.includes(eventId.toLowerCase());
};
const getUUid = () => {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
};
/** Escapes all other characters than +, which is URI encoded */
function encodeStringValue(str) {
    if (str == null || str === '') {
        return str;
    }
    let result = escape(str);
    if (result.indexOf('+') > -1) {
        result = result.replace(/\+/g, '%2B');
    }
    return result;
}
export const makePicQuery = (forceBack = false, iForm, iPICInputFields, iParmsObj) => {
    var _a, _b, _c, _d, _e;
    let picInputFields = iPICInputFields !== null && iPICInputFields !== void 0 ? iPICInputFields : PIC.getInstance.picInputs;
    let picform = iForm ? iForm : document.PICForm;
    let allEls = picform.elements;
    let picQuery = new Map(); //TDO make to map or object instead .... and use util method
    let skipFields = ['__defaultchoice', '__defaultSugg'];
    let preventable = false;
    let preventElm = document.getElementById('preventableEventLst');
    let valid = true;
    let eventid = PIC.getInstance.eventid > '' ? PIC.getInstance.eventid : (_a = iParmsObj === null || iParmsObj === void 0 ? void 0 : iParmsObj.eventid) !== null && _a !== void 0 ? _a : '';
    if (!preventElm && document.activeElement instanceof PICLoadPage)
        preventElm = document.activeElement.shadowRoot.getElementById('preventableEventLst');
    if (forceBack) { //for imitating a 'back' call to the server
        preventable = checkPreventableEvent(preventElm, eventid);
        picQuery.set('eventid', 'back');
        picQuery.set('moduleId', PIC.getInstance.moduleId);
        picQuery.set('SessionCode', PIC.getInstance.sessionCode);
        picQuery.set('SystemId', PIC.getInstance.systemId);
        picQuery.set('Subwin', PIC.getInstance.subwin);
        picQuery.set('datemode', PIC.getInstance.datemode);
    }
    else {
        //Normal inputs added to form - non-webcomponents
        for (let i = 0; i < allEls.length; i++) {
            let element = allEls[i];
            //Skip all irrelevant objects
            if (element instanceof HTMLFieldSetElement
                || element instanceof HTMLObjectElement
                || skipFields.includes(element.name) // dont submit nls hidden fields
                || element.name.startsWith('pic-tabpanelgrp') // dont submit radiobuttons for tabs 
                || element instanceof HTMLOutputElement
                || element.type === 'button'
                || element.type === 'submit'
                || element.value == undefined
                || element.name === '') {
                continue;
            }
            /* specific old-table checkbox fix - don't return checked valued that have been filtered - can be disabled if row contains class submitHidden */
            if (element instanceof HTMLInputElement && element.type === 'checkbox') {
                let isInTable = (_c = (_b = element.closest('table')) === null || _b === void 0 ? void 0 : _b.classList.contains('pic-table')) !== null && _c !== void 0 ? _c : false;
                if (isInTable) {
                    if (!element.checked)
                        continue;
                    let row = element === null || element === void 0 ? void 0 : element.parentElement.parentElement;
                    let rowIsHidden = (((_d = row.style) === null || _d === void 0 ? void 0 : _d.display) === 'none' && !row.classList.contains('submitHidden')); //...
                    if (rowIsHidden)
                        continue;
                }
            }
            let submitValue = element.value;
            if (element.getAttribute('passwordfield') || element.hasAttribute('passwordfield')) {
                //Always encodes passwords
                submitValue = String.fromCharCode(3) + ProgressEncode(submitValue);
            }
            if (picQuery.has(element.name))
                picQuery.set(element.name + '_' + getUUid(), escape(submitValue));
            else
                picQuery.set(element.name, escape(submitValue));
        }
        //load in all system variables
        preventable = checkPreventableEvent(preventElm, (_e = eventid.split('#')[0]) !== null && _e !== void 0 ? _e : '');
        picQuery.set('appVersion', PIC.getInstance.appVersion);
        /* setfocused element */
        let focusElm;
        if (window.submitFocusElm) {
            focusElm = window.submitFocusElm;
            window.submitFocusElm = undefined;
        }
        else if (document.activeElement instanceof PICLoadPage) {
            focusElm = picform.getRootNode().activeElement;
        }
        else {
            focusElm = document.activeElement;
        }
        if (focusElm)
            picQuery.set('focusedElement', escape(focusElm.id));
        if (iParmsObj)
            for (let curNam in iParmsObj) {
                picQuery.set(curNam, iParmsObj[curNam]);
            }
        //load all inputs from webcomponents
        if (picInputFields.size > 0) {
            for (let [id, element] of picInputFields) { //Does it have to be type String ?? Yes
                let submitValue = '';
                let castedElem = element;
                if (castedElem.nodeName === 'PIC-TREE') {
                    let moveData = escape(castedElem.movedItems);
                    picQuery.set(id + '_moved', moveData);
                }
                if (castedElem.nodeName === 'PIC-WEBTABLE') { //extra submitvalue for table that can both mark and select 
                    let selectedRowValues = escape(castedElem.selectedRowValues);
                    picQuery.set(id + '_selectedvalues', selectedRowValues);
                    if (castedElem.editable) {
                        let tableValues = castedElem.inputValues;
                        if (tableValues != null)
                            picQuery.set(id + '_inputvalues', escape(tableValues));
                    }
                }
                submitValue = castedElem.submitValue;
                if (element.getAttribute('passwordfield') || element.hasAttribute('passwordfield')) {
                    //Always encodes passwords
                    submitValue = String.fromCharCode(3) + ProgressEncode(submitValue !== null && submitValue !== void 0 ? submitValue : '');
                }
                submitValue = encodeStringValue(submitValue);
                if (preventable && !castedElem.validateSubmit()) {
                    valid = false;
                    if (castedElem instanceof PICInput) {
                        castedElem.showFullError = true;
                    }
                }
                if (element.nodeName === 'INPUT'
                    && element.type === 'hidden'
                    && element.id) {
                    picQuery.set(element.id, element.value);
                }
                if (submitValue == null)
                    continue;
                picQuery.set(id, submitValue);
            }
        }
    }
    window._log('!Query', valid, picQuery, Util.json2Formdata(picQuery), valid);
    //Util.log('Query', valid, picQuery, Util.json2Formdata(picQuery))
    return valid ? Util.json2Formdata(picQuery) : false;
};
//Opens a choicebox with relevant error message
export const doErrorMsg = (errorIn, errorType, request) => {
    window._log(errorIn, errorType, request);
    let errorMsg = '';
    let errorObj;
    /* check for blocking loadpages*/
    // document.querySelectorAll('pic-loadpage').forEach(lp=>{
    // })
    try {
        errorObj = JSON.parse(errorIn);
        openChoiceBox('pic-choicebox[choicebox-x]', errorObj);
    }
    catch (error) {
        switch (errorType) {
            case '#error': break;
            case 'errorStatus':
                errorMsg = PIC.getInstance.userConfig.userLang === 'da' ? 'Noget gik galt under forespørgslen' : 'Something went wrong, or the request timed out';
                break;
            case 'error':
            case 'unhandled':
                errorMsg = PIC.getInstance.userConfig.userLang === 'da' ? 'System fejl, forespørgslen er fejlet!' : 'System error, request failed!';
                if (errorType === 'unhandled')
                    console.warn('Unhandled situation', request === null || request === void 0 ? void 0 : request.response);
                break;
            default:
                errorMsg = errorIn;
                break;
        }
        //If choicebox notavailable then use built in Alert
        let cb = document.querySelector('pic-choicebox[choicebox-x]');
        window._log(errorMsg);
        if (cb) {
            cb.data = {
                choiceTitle: errorMsg,
                choices: [
                    { choiceText: 'OK', choiceEvent: '' }
                ]
            };
            try {
                window._warn('Error box', errorIn, errorType, errorMsg);
                cb.openBox();
                if (cb.btns.length > 0)
                    cb.btns[0].focus();
            }
            catch (ignore) { }
        }
        else
            alert(errorMsg);
    }
    Util.clearLoadingScreen();
    window.allowSubmit = true; //legacy
};
const newDocumentLoaded = () => {
    var _a;
    let activeElement = document.activeElement;
    if (activeElement && activeElement.hasOwnProperty('blur'))
        activeElement.blur();
    //FIXME has not yet been instantiated!
    let session = PIC.getInstance.sessionCode;
    if (session == null)
        session = '';
    let subwin = PIC.getInstance.subwin;
    let state = { sessionCode: session, subwin: subwin };
    window._log('New doc state', state, window.PIC);
    // console.log('Pushing State', history.state, state)
    if ('documentMode' in document) { //IE11
        window.history.pushState(state, '', location.pathname);
    }
    else
        window.history.pushState(state, '', '');
    sessionStorage.removeItem('updatingStates');
    // look for new channels
    ;
    document.querySelectorAll('input[name=__startnotification__]').forEach((inelm) => { PIC.getInstance.startNotificationChannel(inelm.value); });
    ;
    document.querySelectorAll('input[name=__startnotificationapi__]').forEach((inelm) => {
        if (inelm.value.indexOf(';') > -1)
            PIC.getInstance.startNotificationAPI(inelm.value.split(';')[0], Number(inelm.value.split(';')[1]));
        else
            PIC.getInstance.startNotificationAPI(inelm.value);
    });
    window.removeEventListener('DOMContentLoaded', newDocumentLoaded);
    // Store response in appstack
    if (document) {
        PIC.getInstance.addToStack({ response: PIC.getInstance.getHiddenFields() }, true);
        PIC.getInstance.mailAppStackDecider();
    }
    const immediateEvent = document.querySelector('input[name=__immediateevent__]');
    const eventidInput = document.getElementById('eventid');
    if (immediateEvent instanceof HTMLInputElement && ((_a = immediateEvent.value) === null || _a === void 0 ? void 0 : _a.length) > 0 && eventidInput) {
        eventidInput.value = immediateEvent.value;
        setTimeout(() => document.PICForm.dispatchEvent(new Event('submit', { cancelable: true })), 0);
    }
};
const submitForm = (body) => {
    var _a;
    if (window.loadNewBundle !== null) {
        window.loadNewBundle = (PIC.isTeamTools && ['udv', 'sfltest', 'rnd1_test', 'rnd2_test', 'rnd3_test'].includes((_a = PIC.systemId) !== null && _a !== void 0 ? _a : '')) ? true : false;
    }
    let picSubmitEvent;
    if ('documentMode' in document) { //IE11
        picSubmitEvent = document.createEvent('CustomEvent');
        picSubmitEvent.initCustomEvent('PICSubmit', true, true, { body: body });
    }
    else {
        picSubmitEvent = new CustomEvent('PICSubmit', {
            detail: {
                body: body
            }
        });
    }
    window._log('Dispatching PIC event', picSubmitEvent);
    window.dispatchEvent(picSubmitEvent);
    if (picSubmitEvent.defaultPrevented) {
        window._log('Preventing PIC event', picSubmitEvent);
        return;
    }
    PIC.getInstance.clearTimeouts();
    PIC.getInstance.clearIntervals();
    let oldSessionCode = PIC.getInstance.sessionCode;
    let req = new XMLHttpRequest();
    if ('documentMode' in document)
        req.open('POST', location.pathname); //IE11
    else
        req.open('POST', '');
    req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    req.onload = function () {
        var _a, _b, _c, _d, _e;
        window._log('web2pro response', req);
        PIC.getInstance.addToStack({ responsecode: req.status, response: req.response }, true);
        if (req.status == 200) {
            if (req.response.substring(0, 15).toLowerCase() === '<!doctype html>') {
                let closeSocketsEvent = new CustomEvent('ClosePicSockets', {
                    detail: {}
                });
                window.dispatchEvent(closeSocketsEvent);
                sessionStorage.removeItem('session');
                PIC.getInstance.clearSubEvents();
                if (document && document.body && document.body.innerHTML)
                    document.body.innerHTML = '';
                PIC.getInstance.storage.setItem('fetchFormData', false, 'internal');
                PIC.getInstance.setSubmitButton(null);
                if (window.loadNewBundle) {
                    openNewTab(req.response);
                    window.close();
                }
                else {
                    window.submitOverridden = false;
                    document.write(req.response);
                    document.close();
                    //The write built a new <html>, so data-theme is gone - restore it before paint.
                    PIC.getInstance.userConfig.applyTheme();
                    Util.setLogFunctions();
                    //GlobEvents?
                    window.addEventListener('DOMContentLoaded', newDocumentLoaded);
                    window.addEventListener('DOMContentLoaded', setSubmitListener);
                    window.addEventListener('DOMContentLoaded', setOnPopState);
                    window.addEventListener('DOMContentLoaded', () => {
                        PIC.getInstance.PICWinMap.delete(oldSessionCode);
                        PIC.getInstance.PICWinMap.set(PIC.getInstance.sessionCode, document.documentElement);
                    });
                    PIC.getInstance.events.setGlobalListeners();
                    window.allowSubmit = true;
                }
            }
            else if (req.response.charAt(0) === '#') {
                let responseArr = req.response.split('#');
                if (req.response.startsWith('#openURL')) { //follows mobile scheme of #<cmd>,<data>
                    Util.clearLoadingScreen();
                    window.open(req.response.substring(9), '_blank');
                }
                else if (responseArr.length == 2)
                    doErrorMsg(unescape(responseArr[1]), '#');
                else {
                    switch (responseArr[1]) {
                        case 'loadpage':
                            //tmp
                            //let matchHash = req.response.match(/#/g)?.length
                            if (responseArr.length > 3) {
                                doErrorMsg("", 'error');
                                return;
                            }
                            let loadPageParms = JSON.parse(unescape(responseArr[2]));
                            loadPage(loadPageParms.path, (_a = loadPageParms.parm) !== null && _a !== void 0 ? _a : '', {
                                closeEvent: (_b = loadPageParms.closeEvent) !== null && _b !== void 0 ? _b : undefined,
                                isNew: PIC.WebWersion == '3',
                                system: (_c = loadPageParms.system) !== null && _c !== void 0 ? _c : undefined
                            });
                            if (PIC.getInstance.webVersion !== '3')
                                Util.clearLoadingScreen();
                            window.allowSubmit = true; //legacy
                            let cb = document.querySelector('pic-choicebox[choicebox-x]');
                            if (cb)
                                cb.closeBox();
                            break;
                        case 'getans':
                            //tmp
                            if (responseArr.length > 3) {
                                doErrorMsg("", 'error');
                                return;
                            }
                            /* Load base getAns (small modal) on page, like a choicebox  */
                            let getAnsHtml = unescape(responseArr[2]);
                            let parser = new DOMParser();
                            let getAnsDoc = parser.parseFromString(getAnsHtml, 'text/html');
                            let getAnsDocEl = getAnsDoc.documentElement.querySelector('pic-getans');
                            if (getAnsDocEl) {
                                getAnsHtml = (_d = getAnsDocEl === null || getAnsDocEl === void 0 ? void 0 : getAnsDocEl.innerHTML) !== null && _d !== void 0 ? _d : '';
                                let getAnsElement = document.querySelector('pic-getans#base-ans');
                                if (!getAnsElement) {
                                    getAnsElement = document.createElement('pic-getans');
                                    getAnsElement.isHidden = true;
                                    getAnsElement.setAttribute('id', 'base-ans');
                                    document.body.append(getAnsElement);
                                }
                                getAnsElement.innerHTML = ``;
                                getAnsElement.innerHTML = getAnsHtml;
                                getAnsElement.setAttribute('title', getAnsDocEl.title);
                                getAnsElement.isHidden = false;
                                let hiddenModal = (_e = getAnsElement.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('pic-modal');
                                if (hiddenModal && !hiddenModal.isHidden) {
                                    window.addEventListener('keydown', hiddenModal.handleKeys);
                                    // hiddenModal.blockBackground = true;
                                }
                            }
                            else {
                                //TODO display error box
                                console.log('Failed to open getAns box', JSON.parse(getAnsHtml[2]));
                            }
                            Util.clearLoadingScreen();
                            break;
                        case 'cmd':
                            //tmp
                            if (responseArr.length > 3) {
                                doErrorMsg("", 'error');
                                return;
                            }
                            try {
                                let commands = null;
                                //try parsing both as base64encoded and plain text, for legacy reasons
                                try {
                                    let decoded = atob(responseArr[2]);
                                    commands = objectDecoder(decoded);
                                }
                                catch (e) {
                                    try {
                                        commands = objectDecoder(responseArr[2]);
                                    }
                                    catch (e2) {
                                        try {
                                            commands = JSON.parse(atob(responseArr[2]));
                                        }
                                        catch (e3) {
                                            Util.clearLoadingScreen();
                                            doErrorMsg("", 'error');
                                            console.error('Failed to parse command object', responseArr[2]);
                                            console.log(e, e2, e3);
                                            return;
                                        }
                                    }
                                }
                                window.allowSubmit = true; //legacy
                                Util.clearLoadingScreen();
                                if (commands) {
                                    /*Set all PICInputs initValue to the value of the input field,
                                      Fixes commands not updating the initValue of PICInputs,
                                      Which is used for all kinds of checks, like change*/
                                    const picInputs = PIC.getInstance.picInputs;
                                    picInputs.forEach(input => {
                                        if (input instanceof PICInput) {
                                            input.initValue_ = input.submitValue;
                                        }
                                    });
                                    commands.commands.forEach(cmd => {
                                        if (cmd.cmd == 'picaction' && cmd.action) {
                                            let a = new PICAction();
                                            a.actionOptions = cmd.action;
                                            a.triggerEvent();
                                        }
                                    });
                                }
                            }
                            catch (e) {
                                Util.clearLoadingScreen();
                                doErrorMsg('', 'error');
                            }
                            break;
                        case 'fragment':
                            /*
                                Handles a fragment command formatted like '#fragtment#<id>#<html>' (html is/must be pure-content html, no headers etc.)
                                Currently the backend handles setting fragment ids on groups and returning the pure html.
                                EventTimer & Focus are not handled
                            */
                            let fragtmentId = responseArr[2];
                            let fragtmentHTML = req.response.substring(req.response.indexOf('#', 11) + 1);
                            if (!fragtmentId) {
                                console.warn('no id');
                                doErrorMsg('No fragment Id', '');
                                return;
                            }
                            let fragmentContainer = PIC.getInstance.findElementByIdDeep(fragtmentId);
                            if (!fragmentContainer || !fragmentContainer.classList.contains('fragment-container')) {
                                console.warn('no container', fragtmentId);
                                doErrorMsg('Could not find fragment container', '');
                                return;
                            }
                            //Remove all elements neatly, to ensure disconnectedCallbacks etc. is called
                            //(fixes bug where an item is removed from PIC.inputs if inserted twice)
                            while (fragmentContainer.firstElementChild) {
                                fragmentContainer.firstElementChild.remove();
                            }
                            //could parse the DOM here..., but should actually not be needed (?)
                            fragmentContainer.innerHTML = fragtmentHTML;
                            Util.clearLoadingScreen();
                            break;
                        default:
                            console.error('unhandled #command:', responseArr[1]);
                            doErrorMsg("", 'error');
                            break;
                    }
                }
            }
            else if (req.response === 'error') {
                doErrorMsg("", 'error');
            }
            else {
                //handle non-html && non-#-commands other than 'error'
                doErrorMsg('', 'unhandled', req);
            }
        }
        else { //Server errors (5xx), Client errors (4xx) and timeouts ( > 1min)
            doErrorMsg('', 'errorStatus', req);
        }
    };
    req.onerror = function () {
        //TODO Error handling when submit fails
        Error("Network Error");
    };
    req.send(body);
};
/**
 * Run at startup / whenever - overrides the browser back function whenever a state gets popped
 * Currently does not work if in new tab (team tools)
 */
export const setOnPopState = () => {
    window.onpopstate = function () {
        if (sessionStorage.getItem('updatingStates') !== 'true') {
            window._log('Popstate function');
            setTimeout(function () {
                sessionStorage.setItem('updatingStates', 'true');
                Util.setLoadingScreen();
                let query = makePicQuery(true);
                // console.log('Query With', query)
                if (query)
                    submitForm(query);
            }, 0);
        }
    };
};
const openNewTab = (body, picQuery) => {
    PIC.getInstance.openNewWindow = false;
    let newWin = window.open('/', '_blank');
    let newDoc = newWin === null || newWin === void 0 ? void 0 : newWin.document;
    if (newWin && newDoc) {
        /* Load pic and other stuff */
        newDoc.write(body);
        newDoc.close();
        /* Location fix */
        newWin.history.replaceState(null, '', document.location.href);
        newWin.history.pushState(null, '', '');
        /* Transfer submit data */
        newWin.externalSubmitData = picQuery;
        /* Recursive popup guard - tools users */
        newWin.loadNewBundle = null;
        return newWin;
    }
};
const timedSubmit = (newWin, delay) => {
    newWin === null || newWin === void 0 ? void 0 : newWin.setTimeout(() => newWin === null || newWin === void 0 ? void 0 : newWin.document.PICForm.dispatchEvent(new Event('submit', { cancelable: true })), delay);
};
/**
 * Overrides the submitlistener on PICForm, run at DOMContentLoaded, or whenever the form is ready before user input
 */
export const setSubmitListener = () => {
    window._log('Adding submit listener', (window.submitOverridden ? 'Overridden' : ''));
    if (window.submitOverridden) {
        return;
    }
    window.submitOverridden = true;
    sessionStorage.setItem('fetchFormData', 'true');
    let picform = document.PICForm;
    if (typeof picform === 'undefined' || !picform) {
        if (PIC.getInstance.fromProgress) {
            console.warn('No PICForm found! Cannot perform body replacement');
            return;
        }
        else {
            /* not progress functionallity goes here */
            console.log('Not running from progress, picform will not be replaced');
        }
    }
    else {
        function submit(event) {
            event.preventDefault();
            let picQuery;
            /* This will run in newly opened tab, on first submit */
            if (window.externalSubmitData) {
                picQuery = window.externalSubmitData;
                window.externalSubmitData = undefined;
                PIC.getInstance.ctrlKeyIsDown = false;
                PIC.getInstance.openNewWindow = false;
                let disposableInputSetting = document.PICForm.querySelector('#SessionOption');
                disposableInputSetting === null || disposableInputSetting === void 0 ? void 0 : disposableInputSetting.remove();
            }
            else {
                picQuery = makePicQuery();
            }
            window._log('Made query', picQuery);
            PIC.getInstance.addToStack({ timestamp: new Date(), query: picQuery, request: PIC.getInstance.getHiddenFields() });
            if (picQuery !== false) {
                if (PIC.getInstance.openNewWindow) {
                    let newTab = openNewTab(document.documentElement.innerHTML, picQuery);
                    timedSubmit(newTab, 30);
                }
                else {
                    Util.setLoadingScreen();
                    submitForm(picQuery);
                }
            }
            else {
                window.allowSubmit = true;
                return false;
            }
        }
        picform.removeEventListener('submit', submit);
        picform.addEventListener('submit', submit);
    }
};
//# sourceMappingURL=fetchformdata.js.map